export function buildUpdateStatusSchedulerPayload(form = {}) {
  return {
    action: 'update_status',
    scheduler_id: form.scheduler_id,
    campaign_id: form.campaign_id,
    lead_form_id: form.lead_form_id,
    trigger_delay: form.trigger_delay,
    trigger_delay_unit: form.trigger_delay_unit,
    trigger_time: `${form.trigger_delay ?? ''} ${form.trigger_delay_unit ?? ''}`,
    currentStatus: form.currentStatus,
    nextStatus: form.nextStatus,
    description: form.description,
    active: form.active,
  };
}

export function buildLeadSummarySchedulerPayload(form = {}) {
  return {
    action: 'send_lead_summary',
    scheduler_id: form.scheduler_id,
    campaign_id: form.campaign_id,
    lead_form_id: form.lead_form_id,
    trigger_time: form.frequency === 'Weekly' ? '1 week' : form.frequency,
    schedule_time: form.sendTime,
    timezone: form.timezone || 'Asia/Kolkata',
    notification_config: {
      template_id: form.template?.name ?? form.notification_config?.template_id ?? '',
      bot_number: form.template?.bot_number ?? form.notification_config?.bot_number ?? '',
      min_open_leads_threshold: form.min_open_leads_threshold ?? 1,
    },
  };
}

export function buildSchedulerPayload(form = {}) {
  if (form.action === 'update_status') return buildUpdateStatusSchedulerPayload(form);
  if (form.action === 'send_lead_summary') return buildLeadSummarySchedulerPayload(form);
  return {};
}
